import { ValueOf } from '../../common/utils';
import { BrandItemV2 } from '../../brand/list';
import { EventItemV2 } from '../../event';
import { PRODUCT_STATUS_V2, ProductItemV2 } from '../../product';
import { ReviewItemV2 } from '../../review/list';
import { TagItemV2 } from '../../tag';

export type WidgetAttachment<AttachmentType> = {
  id?: number;
  type: AttachmentType;
  height: number;
  width: number;
  url: string;
};

export const WIDGET_EXPOSURE_PAGE_TYPE_V2 = {
  MAIN: 'main',
  SUB: 'sub',
} as const;
export type WIDGET_EXPOSURE_PAGE_TYPE_V2 = ValueOf<typeof WIDGET_EXPOSURE_PAGE_TYPE_V2>;

export type WidgetProductFilterOption = Partial<
  Pick<ProductItemV2, 'brandName' | 'brandId' | 'name' | 'id' | 'brandStatus'> & {
    mainCategoryList?: number | null;
    status: PRODUCT_STATUS_V2 | null;
  }
>;

export type WidgetBrandFilterOption = Partial<Pick<BrandItemV2, 'id' | 'name' | 'status'>>;

export type WidgetEventFilterOption = Partial<Pick<EventItemV2, 'id' | 'status' | 'mainTitle' | 'contents' | 'memo'>>;

export type WidgetReviewFilterOption = Partial<
  Pick<ReviewItemV2, 'id' | 'content' | 'brandId' | 'brandName' | 'productId' | 'productName'>
>;

export type WidgetTagFilterOption = Partial<Pick<TagItemV2, 'id' | 'name'>>;
